<template>
    <div id="labels">
        <div id="forest_label">
            <p id="forest_text">Forest</p>
        </div>
        <div id="traditional_label">
            <p id="traditional_text">Traditional</p>
        </div>
    </div>
    <div id="graphs">
        <div id="forest_graph">
            <svg id="forest_sp1" viewBox="0 0 940 800">
             <image id="supply" href="../assets/Binder.svg" height="15%" width="15%" x="17.5%" y="5%"/>
             <text class="supply_text" x="25%" y="23%">Binder</text>
             <image id="supply" href="../assets/Clipboard.svg" height="15%" width="15%" x="42.5%" y="5%"/>
             <text class="supply_text" x="50%" y="23%">Clipboard</text>
             <image id="supply" href="../assets/Fleece.svg" height="15%" width="15%" x="67.5%" y="5%"/>
             <text class="supply_text" x="75%" y="23%">Midlayer</text>
             <image id="supply" href="../assets/Folder.svg" height="15%" width="15%" x="17.5%" y="25%"/>
             <text class="supply_text" x="25%" y="43%">Folder</text>
             <image id="supply" href="../assets/Markers.svg" height="15%" width="15%" x="42.5%" y="25%"/>
             <text class="supply_text" x="50%" y="43%">Markers</text>
             <image id="supply" href="../assets/Mittens.svg" height="15%" width="15%" x="67.5%" y="25%"/>
             <text class="supply_text" x="75%" y="43%">Mittens</text>
             <image id="supply" href="../assets/Paper.svg" height="15%" width="15%" x="17.5%" y="45%"/>
             <text class="supply_text" x="25%" y="63%">Paper</text>
             <image id="supply" href="../assets/Socks.svg" height="15%" width="15%" x="42.5%" y="45%"/>
             <text class="supply_text" x="50%" y="63%">Warm Socks</text>
             <image id="supply" href="../assets/WaterproofBoots.svg" height="15%" width="15%" x="67.5%" y="45%"/>
             <text class="supply_text" x="75%" y="63%">Waterproof Boots</text>
             <image id="supply" href="../assets/WarmHat.svg" height="15%" width="15%" x="17.5%" y="65%"/>
             <text class="supply_text" x="25%" y="83%">Warm Hat</text>
             <image id="supply" href="../assets/WaterproofCoat.svg" height="15%" width="15%" x="42.5%" y="65%"/>
             <text class="supply_text" x="50%" y="83%">Waterproof Coat</text>
             <image id="supply" href="../assets/WaterproofPants.svg" height="15%" width="15%" x="67.5%" y="65%"/>
             <text class="supply_text" x="75%" y="83%">Waterproof Pants</text>
            </svg>
        </div>
        <div id="traditional_graph">
            <svg id="traditional_sp1" viewBox="-15 50 940 800">
             <image id="supply" href="../assets/Pencils.svg" height="15%" width="15%" x="22.5%" y="22.5%"/>
             <text class="supply_text" x="30%" y="40.5%">Pencils</text>
             <image id="supply" href="../assets/Markers.svg" height="15%" width="15%" x="22.5%" y="62.5%"/>
             <text class="supply_text" x="30%" y="80.5%">Markers</text>
             <image id="supply" href="../assets/Erasers.svg" height="15%" width="15%" x="42.5%" y="42.5%"/>
             <text class="supply_text" x="50%" y="61%">Erasers</text>
             <image id="supply" href="../assets/Scissors.svg" height="15%" width="15%" x="62.5%" y="22.5%"/>
             <text class="supply_text" x="70%" y="40.5%">Scissors</text>
             <image id="supply" href="../assets/Crayons.svg" height="15%" width="15%" x="62.5%" y="62.5%"/>
             <text class="supply_text" x="70%" y="80.5%">Crayons</text>
            </svg>
        </div>
    </div>
    <div>
        <p id="context1">The supplies shown are based on the beginning of the year school supply list sent out to families that they are expected to provide. 
        The main difference being the additional items (and therefore money) needed to enable the students to be outdoors in all weather for the Forest programs.</p>
    </div>
</template>

<script>
import programs from '../assets/programs.json'

export default {
  name: 'programs',
  data() {
    return {
      supplies_forest: programs[0].Supplies,
      supplies_trad: programs[1].Supplies
    }
  },
  computed: {
  },
  methods: { 
      supply: function(value) {
        return "../assets/"+value+".svg"
      },
      x: function(value,index) {
          if (index%2 == 0){
            return Math.floor(Math.random() * (45 - 25 + 1) + 25)+"%"
        } else {
            return  Math.floor(Math.random() * (75 - 55 + 1) + 55)+"%"
        }
        
      },
      y: function(value,index) {
        return index*30+50+"px"
      }
  },
  components: {
  },
  setup() {
  }
}
</script>

<style>
#supply {
    transform-origin: center;
}

.supply_text {
    text-anchor: middle;
    font-family: Josefin;
    font-size: 1.5vw;
    fill: white;
}

#context1 {
    color: white;
    font-family: Josefin;
    font-size: 1.5vw;
    margin: 0% 10% 1% 10%;
    text-align: center;
}
</style>
